module.exports = __webpack_public_path__ + "img/scene2-3.f1ee7d4c.png";